<!-- Start Footer End -->
<footer class="footer-area">
    <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6" >
            <p style="color: white !important;">Copyright © 2016 Servicios GT</p>
        </div>

        <div class="col-lg-6 col-sm-6 col-md-6 text-end gap">
            <a style="filter: invert(1);" (click)="goToLink('https://servicios.gt/terminos-de-uso')"> <i class="fa fa-gavel"></i> Términos de uso</a> <span style="color: white;">|</span> 
            <a style="filter: invert(1);" (click)="goToLink('https://servicios.gt/politica-de-privacidad')">Política de privacidad <i class="bx bxs-shield-alt-2"></i></a>
        </div>
    </div>
</footer>
<!-- End Footer End -->

<div class="chartjs-colors"> <!-- To use template colors with Javascript -->
    <div class="bg-primary"></div>
    <div class="bg-primary-light"></div>
    <div class="bg-secondary"></div>
    <div class="bg-info"></div>
    <div class="bg-success"></div>
    <div class="bg-success-light"></div>
    <div class="bg-danger"></div>
    <div class="bg-warning"></div>
    <div class="bg-purple"></div>
    <div class="bg-pink"></div>
</div>